import type { LinkPreviewData } from '../components/LinkPreview/types';

export const getYouTubeVideoId = (url: string): string | null => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : null;
};

export const getYouTubeMetadata = async (url: string): Promise<LinkPreviewData> => {
  const videoId = getYouTubeVideoId(url);
  if (!videoId) throw new Error('Invalid YouTube URL');

  const oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`;
  const response = await fetch(oembedUrl);
  const data = await response.json();

  return {
    title: data.title || 'YouTube Video',
    description: data.author_name ? `By ${data.author_name}` : '',
    image: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
    url: url,
    type: 'video'
  };
};